module.exports = __webpack_public_path__ + "img/in.ec75973f.svg";